module.exports = __webpack_public_path__ + "img/skating_2018_001.0a23ad14.jpg";